





































import Vue from 'vue'
import AppLayout from '@rhitics/vue/components/AppLayout.vue'

export default Vue.extend({
  name: 'SimpleInventoryCheck',

  components: {
    AppLayout
  },
  data() {
    return {
      view: 'table',
      items: [
        { title: '財編資料', icon: 'fas fa-table', view: 'table', to: 'asset-check' },
        { title: '條碼產生', icon: 'fas fa-qrcode', view: 'barcode', to: 'barcode-generate' }
      ]
    }
  }
})
